import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function PuneToOutstationCabs() {



  const cardData = {




 keyword: "Pune to Outstation Cabs",

headingDescription: "Garud Cab Service provides dependable Pune to Outstation Cab Service for families, corporate travelers, couples, groups, and passengers planning comfortable long-distance journeys from Pune. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way, round-trip, and customized outstation travel. With experienced drivers, clean and well-maintained cars, flexible pickup locations, transparent pricing, convenient booking options, and 24/7 customer support, we make intercity travel smooth and stress-free. Whether you are planning a weekend getaway, pilgrimage, business trip, family vacation, or multi-city tour, Garud Cab Service provides comfortable and reliable outstation transportation from Pune.",

topPlaces: [
  {
    title: "Pune to Satara Cab",
    description: "Satara is a scenic Maharashtra destination known for Kaas Plateau, Thoseghar Waterfalls, Ajinkyatara Fort, and beautiful Sahyadri landscapes. It is suitable for family trips, nature excursions, weekend holidays, and sightseeing tours from Pune. A private outstation cab provides flexible travel timings and convenient transportation to different attractions around Satara."
  },
  {
    title: "Pune to Sangli Cab",
    description: "Sangli is an important city in western Maharashtra known for its agricultural heritage, temples, Krishna River surroundings, and commercial activity. Travelers from Pune visit Sangli for business, family functions, religious trips, and personal work. Garud Cab Service offers comfortable vehicles for direct one-way and round-trip journeys."
  },
  {
    title: "Pune to Karad Cab",
    description: "Karad is a prominent town in Maharashtra situated near the confluence of the Krishna and Koyna rivers. The destination is known for its educational institutions, historical locations, temples, and pleasant surroundings. A private cab from Pune provides a convenient option for families, students, professionals, and business travelers."
  },
  {
    title: "Pune to Wai Cab",
    description: "Wai is a beautiful town located along the Krishna River and is known for ancient temples, ghats, scenic surroundings, and proximity to popular hill destinations. It is a peaceful option for a short outstation trip from Pune. Travelers can book a comfortable cab for sightseeing, family visits, or weekend travel."
  },
  {
    title: "Pune to Bhandardara Cab",
    description: "Bhandardara is a picturesque hill destination surrounded by mountains, lakes, waterfalls, and lush greenery. Attractions such as Arthur Lake, Randha Falls, and Kalsubai Peak make it popular among nature lovers and adventure enthusiasts. A private outstation taxi allows travelers from Pune to enjoy the journey with flexible stops."
  },
  {
    title: "Pune to Igatpuri Cab",
    description: "Igatpuri is a scenic hill station in Maharashtra known for misty mountains, waterfalls, trekking routes, and peaceful natural surroundings. It is a popular destination for weekend trips and group outings. Garud Cab Service offers comfortable long-distance vehicles for families, couples, and groups traveling from Pune."
  },
  {
    title: "Pune to Matheran Cab",
    description: "Matheran is a unique hill station known for its vehicle-free environment, viewpoints, forests, and pleasant climate. Travelers can enjoy attractions such as Panorama Point, Echo Point, and Charlotte Lake. A private cab from Pune provides convenient transportation to the designated access area before exploring Matheran."
  },
  {
    title: "Pune to Ganpatipule Cab",
    description: "Ganpatipule is a beautiful Konkan destination famous for its seaside Ganpati Temple, clean beaches, coastal scenery, and peaceful atmosphere. It is ideal for pilgrimage trips, family holidays, and coastal vacations. Travelers from Pune can choose a comfortable outstation cab for a relaxed road journey."
  },
  {
    title: "Pune to Amboli Cab",
    description: "Amboli is a lush hill station in Maharashtra known for dense forests, waterfalls, misty roads, and rich biodiversity. It becomes especially scenic during the monsoon season and attracts nature lovers and photographers. A private taxi provides a comfortable way to explore Amboli and nearby scenic locations."
  },
  {
    title: "Pune to Tarkarli Cab",
    description: "Tarkarli is a popular coastal destination in Maharashtra known for clear waters, beaches, Sindhudurg Fort, water sports, and beautiful Konkan scenery. It is ideal for travelers planning a longer beach holiday from Pune. Garud Cab Service provides spacious vehicles for families and groups carrying luggage and travel equipment."
  }
],


 "services": [
  {
    "name": "Pune to Outstation Cab",
    "description": "Book Pune to Outstation Cab for comfortable, safe, and convenient intercity travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury vehicles for family trips, business travel, sightseeing, airport transfers, and flexible one-way or round-trip journeys."
  },
  {
    "name": "Outstation Taxi Service Pune",
    "description": "Choose Outstation Taxi Service Pune for dependable long-distance transportation with professional drivers, clean AC vehicles, flexible pickup locations, and convenient travel options. Services are suitable for family vacations, corporate journeys, religious tours, airport transfers, and planned intercity trips with comfortable chauffeur-driven travel."
  },
  {
    "name": "One Way Cab Pune",
    "description": "Reserve One Way Cab Pune for affordable point-to-point travel without unnecessary return charges. Enjoy direct pickup and drop services, flexible departure timings, experienced chauffeurs, and comfortable AC vehicles for traveling from Pune to Mumbai, Kolhapur, Nashik, Goa, Shirdi, Mahabaleshwar, and other outstation destinations."
  },
  {
    "name": "Best Outstation Cab Service in Pune",
    "description": "Book the Best Outstation Cab Service in Pune for reliable intercity transportation with experienced chauffeurs, clean vehicles, convenient booking, and comfortable journeys. Select from multiple vehicle categories based on passenger count, luggage requirements, trip duration, and destination for family, corporate, tourist, and personal travel."
  },
  {
    "name": "Outstation Cab Service in Pune",
    "description": "Get dependable Outstation Cab Service in Pune for local-to-intercity journeys with professional drivers and well-maintained vehicles. Whether you need a one-way drop, round-trip booking, airport transfer, weekend trip, religious tour, or long-distance family journey, choose a suitable sedan, SUV, or premium cab."
  },
  {
    "name": "Outstation Car Rental Pune",
    "description": "Hire Outstation Car Rental Pune with chauffeur-driven vehicles for comfortable and flexible long-distance travel. Choose from economical sedans, spacious Ertiga and Innova models, premium Innova Crysta, Kia Carens, SUVs, and other options for family holidays, corporate travel, sightseeing, and multi-day outstation trips."
  },
  {
    "name": "Taxi in Pune for Outstation",
    "description": "Book Taxi in Pune for Outstation travel with professional chauffeurs, comfortable AC cars, and flexible trip arrangements. Suitable for one-way drops, round trips, airport transportation, family vacations, business journeys, and sightseeing tours, with vehicle choices available according to group size and luggage needs."
  },
  {
    "name": "Taxi Service in Pune for Outstation",
    "description": "Choose Taxi Service in Pune for Outstation journeys with clean vehicles, experienced drivers, convenient pickup options, and comfortable intercity transportation. Travel to nearby and long-distance destinations with sedan, SUV, Ertiga, Innova, Innova Crysta, and premium cab options for different travel requirements."
  },
  {
    "name": "Book Outstation Cabs Pune",
    "description": "Book Outstation Cabs Pune online for convenient long-distance transportation with quick reservation assistance and multiple vehicle choices. Select one-way or round-trip travel with professional chauffeurs and comfortable AC vehicles for business trips, family vacations, airport transfers, sightseeing, and religious journeys."
  },
  {
    "name": "Cab Booking in Pune for Outstation",
    "description": "Use Cab Booking in Pune for Outstation travel to reserve reliable chauffeur-driven transportation for your preferred destination and schedule. Choose comfortable sedans, SUVs, Ertiga, Innova, Innova Crysta, or Kia Carens according to your group size, luggage requirements, and journey duration."
  },
  {
    "name": "Intercity Cab Pune",
    "description": "Book Intercity Cab Pune for convenient transportation between Pune and destinations across Maharashtra and nearby states. Enjoy comfortable AC vehicles, professional chauffeurs, flexible departure timings, and options for one-way, round-trip, airport, corporate, family, tourist, and religious travel requirements."
  },
  {
    "name": "Intercity Cab Service in Pune",
    "description": "Choose Intercity Cab Service in Pune for smooth and dependable travel between cities with experienced drivers and well-maintained vehicles. The service supports direct drops, return journeys, airport transfers, corporate travel, family trips, sightseeing tours, and long-distance journeys with multiple vehicle categories."
  },
  {
    "name": "One Way Drop Taxi Pune",
    "description": "Reserve One Way Drop Taxi Pune for direct intercity transportation with convenient pickup and destination drop-off. Avoid the need for a return booking while enjoying comfortable AC vehicles and professional chauffeurs for routes from Pune to Mumbai, Nashik, Kolhapur, Goa, Shirdi, Mahabaleshwar, and other cities."
  },
  {
    "name": "Outstation Cabs Mumbai to Pune",
    "description": "Book Outstation Cabs Mumbai to Pune for comfortable and reliable intercity travel between Mumbai and Pune. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury vehicles with professional chauffeurs for one-way drops, round trips, corporate travel, airport transfers, and family journeys."
  },
  {
    "name": "Outstation Cabs Pune to Mumbai",
    "description": "Reserve Outstation Cabs Pune to Mumbai for convenient city-to-city travel with experienced drivers and clean AC vehicles. Enjoy flexible pickup points, comfortable seating, luggage space, and one-way or return-trip options for airport transfers, business travel, family trips, and personal journeys."
  },
  {
    "name": "Outstation Taxi in Pune",
    "description": "Choose Outstation Taxi in Pune for safe and comfortable long-distance travel with professional chauffeurs and reliable vehicles. Whether traveling alone, with family, or in a group, select from sedan, SUV, Ertiga, Innova, Innova Crysta, and premium cab options for convenient intercity transportation."
  },
  {
    "name": "Outstation Taxi Service in Pune",
    "description": "Book Outstation Taxi Service in Pune for dependable chauffeur-driven travel to destinations across Maharashtra and beyond. Enjoy comfortable AC vehicles, flexible pickup timings, direct one-way drops, round-trip options, and vehicle choices suitable for family vacations, corporate journeys, sightseeing, and religious tours."
  },
  {
    "name": "Pune Airport to Kolhapur Cab",
    "description": "Book Pune Airport to Kolhapur Cab for a convenient airport-to-city transfer with punctual pickup, professional chauffeurs, and comfortable AC vehicles. Choose a sedan, Ertiga, Innova, Innova Crysta, SUV, or premium cab for individual, family, corporate, and group travel requirements."
  },
  {
    "name": "Pune Car Rental Outstation",
    "description": "Hire Pune Car Rental Outstation services for comfortable chauffeur-driven journeys to nearby cities, tourist destinations, airports, and religious locations. Select economical sedans or spacious premium vehicles according to your passenger count, luggage requirements, trip duration, and preferred travel style."
  },
  {
    "name": "Pune to Outstation Taxi",
    "description": "Reserve Pune to Outstation Taxi for reliable intercity transportation with experienced drivers and well-maintained AC vehicles. Enjoy one-way and round-trip options for destinations such as Mumbai, Goa, Nashik, Kolhapur, Shirdi, Mahabaleshwar, and other popular outstation locations."
  },
  {
    "name": "Pimpri Chinchwad to Outstation Cabs",
    "description": "Book Pimpri Chinchwad to Outstation Cabs for comfortable travel from PCMC areas to destinations across Maharashtra and neighboring states. Get convenient doorstep pickup, professional chauffeurs, spacious AC vehicles, and one-way or round-trip options for family, corporate, airport, tourist, and personal journeys."
  },
  {
    "name": "PCMC to Outstation Cab Booking",
    "description": "Choose PCMC to Outstation Cab Booking for convenient chauffeur-driven transportation from Pimpri Chinchwad to multiple intercity destinations. Select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or luxury vehicles based on passenger capacity and travel requirements."
  },
  {
    "name": "Book Innova Crysta for Outstation",
    "description": "Book Innova Crysta for Outstation travel when you need spacious seating, premium interiors, generous luggage capacity, and comfortable long-distance transportation. The chauffeur-driven Innova Crysta is suitable for family vacations, corporate journeys, airport transfers, religious tours, sightseeing, and multi-day road trips."
  },
  {
    "name": "Book Ertiga for Outstation in Pune",
    "description": "Book Ertiga for Outstation in Pune for comfortable family and group travel with spacious seating, practical luggage capacity, and smooth AC transportation. The chauffeur-driven Ertiga is suitable for one-way drops, round trips, weekend vacations, airport transfers, sightseeing, and long-distance journeys."
  },
  {
    "name": "Maruti Ertiga Rent Per Day",
    "description": "Get Maruti Ertiga Rent Per Day options in Pune for convenient chauffeur-driven travel and planned outstation journeys. The spacious MPV is suitable for families and small groups requiring comfortable seating, luggage space, flexible schedules, and reliable transportation for local and intercity travel."
  },
  {
    "name": "Ertiga Per Km Rate for Outstation",
    "description": "Check Ertiga Per Km Rate for Outstation travel in Pune and choose a practical vehicle for comfortable long-distance journeys. Ertiga offers spacious seating and useful luggage capacity for family trips, group travel, sightseeing, airport transfers, and one-way or round-trip outstation bookings."
  },
  {
    "name": "Swift Dzire on Rent in Pune for Outstation",
    "description": "Book Swift Dzire on Rent in Pune for Outstation travel when you need an economical and comfortable sedan with a professional chauffeur. The vehicle is suitable for individuals, couples, small families, airport transfers, business journeys, one-way drops, and round-trip intercity travel."
  },
  {
    "name": "Sedan Cab for Outstation",
    "description": "Choose Sedan Cab for Outstation travel for comfortable and budget-friendly intercity transportation with experienced chauffeurs and clean AC vehicles. Sedans are suitable for small families, couples, business travelers, airport transfers, sightseeing, one-way drops, and round-trip journeys from Pune."
  },
  {
    "name": "Kia Carens Rent for Outstation in Pune",
    "description": "Hire Kia Carens Rent for Outstation in Pune for spacious and comfortable family or group journeys with premium seating and generous luggage capacity. The chauffeur-driven vehicle is suitable for vacations, corporate travel, airport transfers, sightseeing, religious tours, and multi-day road trips."
  },
  {
    "name": "Pune to Mumbai Airport Sedan Cab",
    "description": "Book Pune to Mumbai Airport Sedan Cab for a comfortable and punctual airport transfer with professional chauffeurs and clean AC vehicles. Enjoy convenient pickup from Pune locations, direct airport drop service, luggage assistance, and flexible departure timings for domestic or international flights."
  },
  {
    "name": "Pune to Mumbai Airport Dzire Cab",
    "description": "Reserve Pune to Mumbai Airport Dzire Cab for economical and comfortable airport transportation with an experienced chauffeur. Swift Dzire is suitable for individuals, couples, and small families needing reliable pickup, luggage space, direct airport drop, and convenient travel from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai Airport SUV Cab",
    "description": "Choose Pune to Mumbai Airport SUV Cab for spacious and comfortable airport transportation with ample luggage capacity and professional chauffeur service. SUV travel is ideal for families, groups, and business travelers looking for a relaxed journey from Pune to Mumbai Airport."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga Cab",
    "description": "Book Pune to Mumbai Airport Ertiga Cab for convenient group and family airport transfers with spacious seating, luggage capacity, and comfortable AC travel. Enjoy professional chauffeur service, flexible pickup timings, and direct drop at Mumbai Airport for a hassle-free journey."
  },
  {
    "name": "Pune to Mumbai Airport Innova Cab",
    "description": "Reserve Pune to Mumbai Airport Innova Cab for spacious and dependable airport transportation suitable for families and groups. Enjoy comfortable seating, generous luggage space, experienced chauffeurs, timely pickup, and direct airport drop service from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai Airport Innova Crysta",
    "description": "Choose Pune to Mumbai Airport Innova Crysta for a premium airport transfer featuring spacious interiors, comfortable seating, ample luggage space, and professional chauffeur service. It is suitable for families, executives, groups, and travelers seeking a relaxed journey to Mumbai Airport."
  },
  {
    "name": "Pune to Mumbai Airport Luxury Cab",
    "description": "Book Pune to Mumbai Airport Luxury Cab for premium chauffeur-driven transportation with refined interiors, comfortable seating, professional service, and a smooth airport journey. Luxury vehicles are suitable for executives, business travelers, special occasions, and passengers who prefer an elevated travel experience."
  },
  {
    "name": "Pune to Mumbai Airport Tempo Traveller",
    "description": "Reserve Pune to Mumbai Airport Tempo Traveller for group airport transportation with spacious seating and sufficient luggage capacity. It is a convenient choice for families, corporate teams, tour groups, and larger parties traveling together from Pune to Mumbai Airport."
  },
  {
    "name": "Pune to Mumbai Airport Group Taxi",
    "description": "Choose Pune to Mumbai Airport Group Taxi for convenient shared group transportation with spacious vehicles, professional chauffeurs, and comfortable AC travel. Group taxi options are suitable for families, corporate teams, wedding guests, tour groups, and passengers traveling together to Mumbai Airport."
  }
],
"tableData": [
  ["Pune to Outstation Cab", "Outstation Taxi Service Pune"],
  ["One Way Cab Pune", "Best Outstation Cab Service in Pune"],
  ["Outstation Cab Service in Pune", "Outstation Car Rental Pune"],
  ["Taxi in Pune for Outstation", "Taxi Service in Pune for Outstation"],
  ["Book Outstation Cabs Pune", "Cab Booking in Pune for Outstation"],
  ["Intercity Cab Pune", "Intercity Cab Service in Pune"],
  ["One Way Drop Taxi Pune", "Outstation Cabs Mumbai to Pune"],
  ["Outstation Cabs Pune to Mumbai", "Outstation Taxi in Pune"],
  ["Outstation Taxi Service in Pune", "Pune Airport to Kolhapur Cab"],
  ["Pune Car Rental Outstation", "Pune to Outstation Taxi"],
  ["Pimpri Chinchwad to Outstation Cabs", "PCMC to Outstation Cab Booking"],
  ["Book Innova Crysta for Outstation", "Book Ertiga for Outstation in Pune"],
  ["Maruti Ertiga Rent Per Day", "Ertiga Per Km Rate for Outstation"],
  ["Swift Dzire on Rent in Pune for Outstation", "Sedan Cab for Outstation"],
  ["Kia Carens Rent for Outstation in Pune", "Pune to Mumbai Airport Sedan Cab"],
  ["Pune to Mumbai Airport Dzire Cab", "Pune to Mumbai Airport SUV Cab"],
  ["Pune to Mumbai Airport Ertiga Cab", "Pune to Mumbai Airport Innova Cab"],
  ["Pune to Mumbai Airport Innova Crysta", "Pune to Mumbai Airport Luxury Cab"],
  ["Pune to Mumbai Airport Tempo Traveller", "Pune to Mumbai Airport Group Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Pune to Outstation Cabs",
    WhyChoosedescription: "Garud Cab Service provides outstation cab options from Pune for travellers planning intercity journeys, family trips, business visits, holidays, and personal travel with convenient door-to-door transportation."
  },
  {
    WhyChooseheading: "Travel to Multiple Outstation Destinations",
    WhyChoosedescription: "Plan your journey from Pune to destinations across Maharashtra and other parts of India. Whether you are travelling to Mumbai, Nashik, Goa, Kolhapur, Aurangabad, Surat, Indore, or another city, suitable cab options can be arranged."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose a one-way cab when you only need transportation to your destination or select a round-trip booking when you plan to return to Pune after completing your visit."
  },
  {
    WhyChooseheading: "Cars for Couples, Families & Groups",
    WhyChoosedescription: "Vehicle selection can be made according to your passenger count, luggage, and comfort preferences, with options suitable for individual travellers, families, corporate groups, and larger parties."
  },
  {
    WhyChooseheading: "Flexible Pickup from Pune",
    WhyChoosedescription: "Arrange your outstation cab pickup from your home, hotel, office, railway station area, airport, residential society, or another convenient location in Pune."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Garud Cab Service assigns experienced drivers who understand long-distance road travel and can help make your intercity journey comfortable while navigating highways, city roads, and different route conditions."
  },
  {
    WhyChooseheading: "Ideal for Holidays & Business Travel",
    WhyChoosedescription: "Outstation cabs are useful for weekend getaways, family vacations, religious trips, corporate travel, weddings, airport connections, educational visits, and personal journeys between cities."
  },
  {
    WhyChooseheading: "Easy Outstation Cab Booking with Garud",
    WhyChoosedescription: "Share your Pune pickup point, destination, travel date, passenger details, preferred vehicle, and trip type to receive suitable cab options and plan your outstation journey with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Outstation Cabs?",
    answer: "Yes, Garud Cab Service provides outstation cab services from Pune for one-way trips, round trips, family travel, business journeys, holidays, and other intercity requirements."
  },
  {
    question: "Which destinations can I travel to from Pune?",
    answer: "You can arrange cabs to suitable destinations across Maharashtra and other parts of India, depending on the route and vehicle availability."
  },
  {
    question: "Can I book a one-way outstation cab from Pune?",
    answer: "Yes, one-way cab service is available for travellers who only require transportation from Pune to their destination."
  },
  {
    question: "Is round-trip cab service available?",
    answer: "Yes, round-trip bookings can be arranged when you want to travel from Pune to an outstation destination and return after your visit."
  },
  {
    question: "Which vehicles are available for outstation travel?",
    answer: "Vehicle options depend on availability and can be selected according to passenger count, luggage requirements, journey distance, and preferred comfort level."
  },
  {
    question: "Can families book Pune outstation cabs?",
    answer: "Yes, families can choose a suitable vehicle based on the number of passengers, luggage, and travel requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, residential areas, railway station areas, airports, and other convenient locations in Pune."
  },
  {
    question: "Are Pune outstation cabs suitable for corporate travel?",
    answer: "Yes, corporate travellers can use outstation cabs for business meetings, site visits, conferences, employee travel, and intercity work-related journeys."
  },
  {
    question: "Can I book an outstation cab for a religious trip?",
    answer: "Yes, outstation cabs can be arranged for temple visits, pilgrimage routes, spiritual tours, and other religious travel requirements."
  },
  {
    question: "How can I book a Pune to Outstation Cab?",
    answer: "Share your Pune pickup location, destination, travel date, passenger count, preferred vehicle, and one-way or round-trip requirement to arrange your cab booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Pawar",
    feedback: "We booked an outstation cab from Pune for a family trip to Nashik. The vehicle was comfortable, the pickup was convenient, and the journey was enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Deshmukh",
    feedback: "Garud Cab Service helped us arrange a round-trip cab for an outstation family visit. The booking process was simple and the vehicle suited our group comfortably.",
    rating: 5
  }
];















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstations Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-outstations-cabs.webp",
  "description": "Book reliable Pune to Outstations Cabs with Garud Cab for safe, comfortable, and convenient intercity travel. Choose one way and round trip outstation taxi services from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for family trips, business travel, weekend journeys, and long-distance transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-outstations-cabs"
  }
};


  return (
    <div>
<Helmet>
  <title>Pune to Outstations Cabs | One Way & Intercity Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Outstation Cabs with Garud Cab for reliable one way, round trip, and intercity travel. Get comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis from Pune for outstation journeys."
  />

  <meta
    name="keywords"
    content="Pune to outstation cab, outstation taxi service Pune, one way cab Pune, best outstation cab service in Pune, outstation cab service in Pune, outstation car rental Pune, taxi in Pune for outstation, taxi service in Pune for outstation, book outstation cabs Pune, cab booking in Pune for outstation, intercity cab Pune, intercity cab service in Pune, one way drop taxi Pune, outstation cabs Mumbai to Pune, outstation cabs Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default PuneToOutstationCabs;